import React from "react";

// Kleine Sorten-Signets fuer die angeheftete Geschmacksleiste.
// Strichstaerke und Duktus folgen SeasonIcon/CompassIcon.
const PATHS = {
  // Frühlingsblüte — Bluete mit Stiel
  bloom: (
    <>
      <circle cx="12" cy="9" r="2.1" stroke="currentColor" strokeWidth="1.4" />
      <path d="M12 6.9C12 4.6 10.6 3.2 8.4 3.2c-.2 2.2 1.2 3.7 3.6 3.7Z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" />
      <path d="M12 6.9C12 4.6 13.4 3.2 15.6 3.2c.2 2.2-1.2 3.7-3.6 3.7Z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" />
      <path d="M12 11.1V21" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
      <path d="M12 15c-1.8 0-3-1.1-3.2-3 1.9-.1 3.2 1 3.2 3Z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" />
    </>
  ),
  // Wald — Nadelbaum
  tree: (
    <>
      <path d="M12 3 6.6 11h3L5.8 17h12.4l-3.8-6h3L12 3Z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" />
      <path d="M12 17v4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
    </>
  ),
  // Primavera — Bluetenzweig
  branch: (
    <>
      <path d="M5 21C5 12.7 9.6 7.2 18 5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
      <circle cx="16.6" cy="9.4" r="1.9" stroke="currentColor" strokeWidth="1.4" />
      <circle cx="10.2" cy="14.4" r="1.6" stroke="currentColor" strokeWidth="1.4" />
      <circle cx="19.4" cy="15" r="1.4" stroke="currentColor" strokeWidth="1.4" />
    </>
  ),
  // Estate — Sonne
  sun: (
    <>
      <circle cx="12" cy="12" r="4.4" stroke="currentColor" strokeWidth="1.4" />
      <path
        d="M12 3v2.4M12 18.6V21M21 12h-2.4M5.4 12H3M18.4 5.6l-1.7 1.7M7.3 16.7l-1.7 1.7M18.4 18.4l-1.7-1.7M7.3 7.3 5.6 5.6"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
      />
    </>
  ),
  // Alpenwiese — Berggipfel
  peak: (
    <>
      <path d="M2.6 19.5 9 8.2l3.6 6 2.2-3.4 6.6 8.7H2.6Z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" />
      <path d="M6.8 12.1h4.4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
    </>
  ),
};

function VarietyIcon({ name, size = 18, className = "" }) {
  const path = PATHS[name];
  if (!path) return null;
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      {path}
    </svg>
  );
}

export default VarietyIcon;
